import React from 'react';
import SingleActiveHire from 'components/ActiveHires/SingleActiveHire/SingleActiveHire';

const PinderHireUserCard = ({ endHireUpdateActiveHires, activeHire }) => {
  return (
    <SingleActiveHire
      activeHire={activeHire}
      endHireUpdateActiveHires={endHireUpdateActiveHires}
    />
  );
};

export default PinderHireUserCard;
